const setCartAttributesMaybe = async () => {

    if (window.location.pathname === '/cart') {
        return
    }

    const attributes = {}

    try {
        const location = document.querySelector('.branch-name')?.dataset?.location

        if (!location) {
            return
        }

        attributes['Preferred Store Location'] = location
    }
    catch(e) {
        console.warn('Unable to query branch location', e)
    }

    try {
        const cartResponse = await fetch(`/cart.json`, { method: 'POST' })
        const cartJson = await cartResponse.json()
        const cartToken = cartJson?.token

        if (!cartToken) {
            return
        }

        attributes['Cart Token'] = cartToken
    }
    catch(e) {
        console.warn('Unable to query cart token', e)
    }

    if (!Object.keys(attributes).length) {
        return
    }

    try {
        const updateResponse = await fetch(`/cart/update.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes
            })
        })

        if (updateResponse.status !== 200) {
            throw 'Update cart attributes produced a non 200 response code'
        }
    }
    catch(e) {
        console.warn('Unable to update cart attributes', e)
    }
}

window.onload = async () => {
    setCartAttributesMaybe()
}
